const postLeadService = async (leadId, formData, isLastStep) =>
    await fetch(`/api/leads/${leadId}${isLastStep ? '?lastStep=true' : ''}`, {
        method: 'PUT',
        headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window?.Laravel?.csrfToken || '',
        },
        body: JSON.stringify(formData),
    });

export default postLeadService;
